import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@/context/AuthContext';
import { adminLogin } from '@/lib/api';
import { toast } from 'sonner';
import { Loader2, Lock } from 'lucide-react';

const LOGO_URL = "/coyp-logo.png";

const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const { login, isAuthenticated } = useAuth();

  useEffect(() => {
    if (isAuthenticated) {
      navigate('/admin/dashboard');
    }
  }, [isAuthenticated, navigate]);

  if (isAuthenticated) return null;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await adminLogin(password);
      login(response.data.access_token);
      toast.success('Welcome!');
      navigate('/admin/dashboard');
    } catch (error) {
      toast.error('Invalid password');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-black flex items-center justify-center p-4" data-testid="admin-login-page">
      <div className="w-full max-w-sm bg-[#111] border border-[#222] p-8">
        <div className="text-center mb-8">
          <img 
            src={LOGO_URL} 
            alt="Check On Yo Peoples TV" 
            className="h-16 mx-auto mb-4"
          />
          <p className="text-gray-500 mt-2">Admin Access</p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="text-xs font-bold uppercase tracking-wider text-gray-400 block mb-2">
              Password
            </label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              className="w-full px-4 py-3 bg-black border border-[#222] text-white text-center text-lg tracking-widest focus:outline-none focus:border-yellow-500"
              placeholder="••••••••"
              required
              autoFocus
              data-testid="admin-password-input"
            />
          </div>

          <button
            type="submit"
            disabled={loading}
            className="w-full py-3 bg-yellow-500 text-white font-medium hover:bg-yellow-600 transition-colors disabled:opacity-50 flex items-center justify-center gap-2"
            data-testid="admin-submit-btn"
          >
            {loading && <Loader2 className="w-4 h-4 animate-spin" />}
            Enter
          </button>
        </form>
      </div>
    </div>
  );
};

export default AdminLogin;
